module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-loadable-components-ssr/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"SHARE NOW","short_name":"SHARE NOW","start_url":"/","background_color":"#005478","theme_color":"#0ba1e2","display":"minimal-ui","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"44d1ebe77cd3b3c8a8a354f52eeadf30"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
